import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import CompetitionsService, { CompetitionType, CompetitionTypes } from "../../services/CompetitionsService";
import Moment from "moment";
import styles from "./index.module.sass";
import { DatePicker, DefaultButton, Spinner, SpinnerSize, TextField } from "@fluentui/react";
import { currencyNeutreFormatter } from "../../utils/numberFormatter";
import { CompetitionInitialValues } from "../../services/CompetitionsService";
import { useForm } from "react-hook-form";
import { Toggle } from "@fluentui/react/lib/Toggle";
import { useHistory } from "react-router-dom";
import Auth from "../../Auth/Auth";
import PortfolioModelWalletService, { ModelSavingPlanSelector, ModelWallet, ModelWalletOptions } from "../../services/PortfolioModelWalletService";
import ElementsService, { ElementAmountType } from "../../services/ElementsService";
import { GenericMessageModalWithoutButton } from "../../components/Modals/GenericModal";
import SavingsPlanService from "../../services/SavingsPlanService";
import * as S from '@/components/ConvenienceTest/ConvenienceTest.style';
import { CompetitionSelectCont } from "@/components/competitionSelect/CompetitionSelect.style";
import { DatePickerStyleNoMargin, InputStylesNoMargin } from '@/components/GlobalStyle';
import Select from 'react-dropdown-select';
import { DayPickerStrings } from "../../components/ConvenienceTest/Utils/DatesTranlateFluents";
import { SavingsPlanAndStatusLite } from "../../components/SavePlans/types/SavePlansTypes";

const CompetitionNew = () =>
{
    const [error, setError] = useState({ status: false, message: "" });
    const [loading, setLoading] = useState<boolean>(false);
    const [sending, setSending] = useState<boolean>(false);
    const [name, setName] = useState<string>("");
    const [startDate, setStartDate] = useState<string>("");
    const [startDateInDate, setStartDateInDate] = useState<Date>();
    const [endDate, setEndDate] = useState<string>("");
    const [endDateInDate, setEndDateInDate] = useState<Date>();
    const [price, setPrice] = useState<string>("0");
    const [description, setDescription] = useState<string>("");
    const [summary, setSummary] = useState<string>("");
    const [selectedSavingPlan, setSelectedSavingPlan] = useState<number>();
    const [selectedModelPortfolio, setSelectedModelPortfolio] = useState<number>();
    const [selectedValueCompetition, setSelectedValueCompetition] = useState(false);
    const [isModal, setIsModal] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [haveError, setHaveError] = useState<boolean>(false);
    const [selectedValueType, setSelectedValueType] = useState(false);
    const [savingPlanModelPortfolios, setSavingPlanModelPortfolios] = useState<ModelWalletOptions[]>();
    const [elementsAmount, setElementsAmount] = useState<ElementAmountType>();
    const [starDateOneMonthMoreDate, setStarOneMonthMoreDate] = useState<Date>();
    const [savingsPlans, setSavingsPlans] = useState<ModelSavingPlanSelector[]>();
    const [chargedModelPortfolio, setChargedModelPortfolio] = useState<boolean>(true);

    let history = useHistory();
    const user = Auth.getUserProfile();

    const {handleSubmit} = useForm();

    useEffect(() =>
    {
        SavingsPlanService.getSavingsPlansAndStatusLite(user.id).then((res: any) =>
        {
            const savingPlans = res.filter((e: any) => e.status === 4);

            const spSavingPlans = savingPlans.map((savingPlan: SavingsPlanAndStatusLite) =>
            ({
                value: savingPlan.id,
                label: savingPlan.name
            }));

            setSavingsPlans(spSavingPlans);
        })
        .catch((error: any) =>
        {
            // Sin planes no se puede crear la competición; antes el selector se quedaba con el spinner indefinidamente
            setError({ status: true, message: (typeof error?.response?.data === "string" && error.response.data) || "No se han podido cargar tus planes de cartera. Por favor, inténtalo de nuevo más tarde." });
        })
        .finally(() =>
        {
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() =>
    {
        if(selectedSavingPlan !== undefined)
        {
            setChargedModelPortfolio(false);

            Promise.all(
            [
                PortfolioModelWalletService.getModelWallets(selectedSavingPlan),
                ElementsService.getElementsAmountBySavingsPlanIdCompetition(selectedSavingPlan)
            ])
            .then(([modelPortfolio, elementsAmountAux]) =>
            {
                let spModelPortfolios = modelPortfolio.map((portfolio: ModelWallet) =>
                ({
                    value: portfolio.id,
                    label: portfolio.name,
                }));

                setSavingPlanModelPortfolios(spModelPortfolios);
                setSelectedModelPortfolio(undefined);

                if(elementsAmountAux !== "")
                {
                    setElementsAmount(elementsAmountAux);
                }
                else
                {
                    setElementsAmount(undefined);
                }
            })
            .catch((error: any) =>
            {
                setError({ status: true, message: (typeof error?.response?.data === "string" && error.response.data) || "No se han podido cargar las carteras modelo del plan seleccionado. Por favor, inténtalo de nuevo más tarde." });
            })
            .finally(() =>
            {
                setChargedModelPortfolio(true);
            });
        }
        else
        {
            setSavingPlanModelPortfolios([]);
        }
    }, [selectedSavingPlan]);

    if(error.status)
    {
        return(
            <DocumentTitle title="IronIA - Competiciones">
                <div>Error: {error.message}</div>
            </DocumentTitle>
        );
    }

    const onSubmit = async (data: CompetitionInitialValues) =>
    {
        if(name !== "" && description !== "" && summary !== "" && startDate !== "" && endDate !== "" && selectedModelPortfolio !== undefined && selectedSavingPlan !== undefined
            && ((price !== undefined && parseInt(price) > 0 && elementsAmount !== undefined && selectedValueCompetition === true && parseInt(price) < elementsAmount.elementWater)
                || (elementsAmount !== undefined && selectedValueCompetition === false && price !== undefined && parseInt(price) < elementsAmount.elementIA)))
        {

            setHaveError(false);

            const competitionInitialValues: CompetitionInitialValues =
            {
                name: name,
                startDate: startDate,
                endDate: endDate,
                description: description,
                type: selectedValueType ? 1 : 0,
                price: parseInt(price),
                typeOfPrice: selectedValueCompetition ? 1 : 0,
                modelPortfolio: selectedModelPortfolio.toString(),
                allowOutdatedIncriptions: false,
                userId: user.id,
                savingsPlanId: selectedSavingPlan
            };

            setSending(true);

            CompetitionsService.createCompetition(competitionInitialValues).then((response: CompetitionType) =>
            {
                setIsModal(true);
                setShowModal(true);
            },
            (error: any) =>
            {
                // Sin respuesta del servidor (red, timeout) error.response no existe
                setError({ status: true, message: (typeof error?.response?.data === "string" && error.response.data) || "No se ha podido crear la competición. Por favor, inténtalo de nuevo más tarde." });
            })
            .finally(() =>
            {
                setSending(false);
            });
        }
        else
        {
            setHaveError(true);
        }
    };

    const handleToggleValueCompetitionChange = (event: React.MouseEvent<HTMLElement>, checked: boolean | undefined) =>
    {
        setSelectedValueCompetition(checked ?? false);
    };

    const handleToggleValueTypeChange = (_event: React.MouseEvent<HTMLElement>, checked: boolean | undefined) =>
    {
        setSelectedValueType(checked ?? false);
    };

    const handleStartDateChange = (date: Date | null | undefined) =>
    {
        let dateFormat = Moment(date).format("DD/MM/YYYY");
        const startDateForDate = new Date(date!);

        setStartDateInDate(startDateForDate);
        setStartDate(dateFormat);
        setStarOneMonthMoreDate(Moment(date).add(1, "month").startOf('day').toDate());
    };

    const handleEndDateChange = (date: Date | null | undefined) =>
    {
        const endDateForDate = new Date(date!);
        let dateFormat = Moment(date).format("DD/MM/YYYY");

        setEndDateInDate(endDateForDate!)
        setEndDate(dateFormat);
    };

    return(
        <DocumentTitle title="IronIA - Nueva Competición">
            <section className={`${styles.index}`}>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <h2>Crear Competición</h2>
                    </div>
                </div>
                {loading && <Spinner size={SpinnerSize.large} />}
                {!loading &&
                (
                    <div className="ms-Grid-row" style={{display: "flex"}}>
                        <article className={`${styles.card} rounded background-background`}>
                            <form id="form" onSubmit={handleSubmit(onSubmit)} noValidate>
                                <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                                    <div style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <TextField
                                                label='Nombre'
                                                // @ts-ignore
                                                styles={InputStylesNoMargin}
                                                id={'name'}
                                                name={'name'}
                                                type='text'
                                                value={name}
                                                // Mismo límite que el backend (CompetitionTextRules.MaxNameLength)
                                                maxLength={150}
                                                // @ts-ignore
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                            {haveError && name === "" &&
                                            (
                                                <p style={{ color: "red" }}>Debes rellenar el nombre</p>
                                            )}
                                        </div>
                                        <div style={{ display: "flex" }}>
                                            <S.FieldCont>
                                                <DatePicker
                                                    styles={DatePickerStyleNoMargin}
                                                    label='Comienzo'
                                                    id={'startDate'}
                                                    // @ts-ignore
                                                    name={'startDate'}
                                                    formatDate={(date) =>
                                                    {
                                                        return Moment(date).format('DD/MM/YYYY');
                                                    }}
                                                    onSelectDate={(date) =>
                                                    {
                                                        if (date)
                                                        {
                                                            const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                                                            handleStartDateChange(utcDate);
                                                        }
                                                    }}
                                                    value={startDateInDate}
                                                    isRequired
                                                    strings={DayPickerStrings}
                                                    allowTextInput={true}
                                                    parseDateFromString={(dateStr) =>
                                                    {
                                                        var parts: string[] = dateStr.split('/');
                                                        var myDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
                                                        return new Date(myDate)
                                                    }}
                                                />
                                                {haveError && startDateInDate === undefined && (
                                                    <p style={{ color: "red" }}>Debes rellenar el comienzo</p>
                                                )}
                                                {startDateInDate !== undefined &&
                                                    startDateInDate < Moment().toDate() && (
                                                        <p style={{ color: "red" }}>
                                                            La fecha inicial no puede ser menor al día de hoy
                                                        </p>
                                                    )}
                                            </S.FieldCont>
                                            <S.FieldCont>
                                                <DatePicker
                                                    styles={DatePickerStyleNoMargin}
                                                    label='Final'
                                                    id={'endDate'}
                                                    // @ts-ignore
                                                    name={'endDate'}
                                                    formatDate={(date) =>
                                                    {
                                                        return Moment(date).format('DD/MM/YYYY');
                                                    }}
                                                    onSelectDate={(date) =>
                                                    {
                                                        if (date)
                                                        {
                                                            const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                                                            handleEndDateChange(utcDate);
                                                        }
                                                    }}
                                                    value={endDateInDate}
                                                    isRequired
                                                    strings={DayPickerStrings}
                                                    allowTextInput={true}
                                                    parseDateFromString={(dateStr) =>
                                                    {
                                                        var parts: string[] = dateStr.split('/');
                                                        var myDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
                                                        return new Date(myDate)
                                                    }}
                                                />
                                                {haveError && endDate === "" && (
                                                    <p style={{ color: "red" }}>Debes rellenar el final</p>
                                                )}
                                                {endDateInDate !== undefined && starDateOneMonthMoreDate !== undefined && starDateOneMonthMoreDate > endDateInDate && (
                                                    <p style={{ color: "red" }}>
                                                        La fecha final debe ser cómo mínimo 30 días mayor de la
                                                        fecha inicial
                                                    </p>
                                                )}
                                            </S.FieldCont>
                                        </div>
                                        <div
                                            style={{ marginBottom: "60px !important", marginTop: "10px", }}
                                        >
                                            <p style={{ color: "#556769", fontWeight: "500" }}>
                                                Descripción *
                                            </p>
                                            <div
                                                style={{ display: "flex", flexDirection: "column" }}
                                            >
                                                <textarea
                                                    className="medium"
                                                    style={{ height: "40px", marginTop: "10px", fontFamily: "Barlow", fontSize: "14px", paddingLeft: "10px", paddingRight: "10px", backgroundColor: '#F3F7F9', borderRadius: "4px", border: "1px solid rgb(149, 160, 161)", resize: "none" }}
                                                    name="description"
                                                    maxLength={4000} // Mismo límite que el backend (CompetitionTextRules.MaxDescriptionLength)
                                                    disabled={sending} // @ts-ignore
                                                    onChange={(e) => setDescription(e.target.value)}
                                                />
                                                {haveError && description === "" && (
                                                    <p style={{ color: "red" }}>
                                                        Debes rellenar la descripción
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div
                                            style={{ marginBottom: "60px !important", marginTop: "10px", }}
                                        >
                                            <p style={{ color: "#556769", fontWeight: "500" }}>
                                                Sumario *
                                            </p>
                                            <div
                                                style={{ display: "flex", flexDirection: "column" }}
                                            >
                                                <textarea
                                                    className="medium"
                                                    style={{ height: "60px", marginTop: "10px", fontFamily: "Barlow", fontSize: "14px", paddingLeft: "10px", paddingRight: "10px", backgroundColor: '#F3F7F9', borderRadius: "4px", border: "1px solid rgb(149, 160, 161)", resize: "none" }}
                                                    name="summary"
                                                    disabled={sending} // @ts-ignore
                                                    onChange={(e) => setSummary(e.target.value)}
                                                />
                                                {haveError && summary === "" && (
                                                    <p style={{ color: "red" }}>
                                                        Debes rellenar el sumario
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div
                                            style={{ display: "flex", alignItems: "center", }}
                                        >
                                            <S.FieldPhoneCont>
                                                <TextField
                                                    // @ts-ignore
                                                    styles={InputStylesNoMargin}
                                                    label='Inscripción'
                                                    id={'price'}
                                                    name={'price'}
                                                    type='text'
                                                    value={price} // @ts-ignore
                                                    onChange={(e) => setPrice(e.target.value)} // @ts-ignore
                                                    required
                                                    validateOnFocusIn
                                                />
                                                <p style={{ color: "grey", }}>
                                                    Para inscripción gratuita escribe 0
                                                </p>
                                                {(selectedModelPortfolio !== undefined && elementsAmount === undefined) && <p style={{ color: "red" }}>
                                                    La cantidad de elements que tienes para este plan de cartera es 0

                                                </p>}
                                                {((price !== undefined && parseInt(price) > 0 && elementsAmount !== undefined && selectedValueCompetition === true && parseInt(price) > elementsAmount.elementWater)
                                                    || (elementsAmount !== undefined && selectedValueCompetition === false && price !== undefined && parseInt(price) > elementsAmount.elementIA)) && (
                                                        <p style={{ color: "red" }}>
                                                            No puedes poner más elements de los que tienes. Tu total
                                                            de elements es de{" "}
                                                            {selectedValueCompetition
                                                                ? elementsAmount.elementWater
                                                                : elementsAmount.elementIA}{" "}
                                                        </p>
                                                    )}

                                            </S.FieldPhoneCont>
                                            <div style={{ display: "flex", width: "50%", justifyContent: "center", marginTop: "20px" }}>
                                                <p style={{ marginRight: "5px" }}>Elements IA</p>
                                                <Toggle
                                                    checked={selectedValueCompetition}
                                                    onChange={handleToggleValueCompetitionChange}
                                                    style={{ backgroundColor: "#CC214F" }}
                                                    styles={{
                                                        thumb: {
                                                            backgroundColor: "white",
                                                        },
                                                    }}
                                                />
                                                <p style={{ marginLeft: "5px" }}>Elements Agua</p>
                                            </div>
                                        </div>
                                        <div className="ms-Grid-row" style={{ display: "flex", marginTop: "12px" }}>
                                            <p style={{ marginRight: "5px" }}>Un Ganador</p>
                                            <Toggle
                                                checked={selectedValueType}
                                                onChange={handleToggleValueTypeChange}
                                                style={{ backgroundColor: "#CC214F" }}
                                                styles={{
                                                    thumb: {
                                                        backgroundColor: "white",
                                                    },
                                                }}
                                            />
                                            <p style={{ marginLeft: "5px" }}>Tres ganadores</p>
                                        </div>
                                        <div style={{ display: "flex" }}>
                                            <div
                                                style={{ display: "flex", flexDirection: "column", width: "50%" }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <CompetitionSelectCont>
                                                        <S.Label>Plan de Ahorro</S.Label>
                                                        {/*//@ts-ignore */}
                                                        <Select
                                                            options={savingsPlans ?? []}
                                                            placeholder=""
                                                            onChange={(selectedOptions) =>
                                                            {
                                                                setSelectedSavingPlan(selectedOptions[0].value);
                                                                setSelectedModelPortfolio(undefined);
                                                                setSavingPlanModelPortfolios([]);
                                                            }}
                                                            searchable={false}
                                                            required
                                                        />
                                                    </CompetitionSelectCont>
                                                    {savingsPlans === undefined && <div style={{ marginLeft: "20px", marginTop: "30px" }}>
                                                        <Spinner size={SpinnerSize.small} style={{ marginTop: "60x" }} className="button-spinner" />
                                                    </div>}


                                                </div>
                                                {haveError && selectedSavingPlan === undefined && (
                                                    <p className="ms-Grid-col ms-sm6 ms-md6 ms-lg6 ms-xl6" style={{ color: "red" }}>
                                                        Debes seleccionar un plan de cartera
                                                    </p>
                                                )}
                                            </div>
                                            <div
                                                style={{ display: "flex", flexDirection: "column", width: "50%" }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <CompetitionSelectCont>
                                                        <S.Label>Cartera Modelo</S.Label>
                                                        {/*//@ts-ignore */}
                                                        <Select
                                                            options={savingPlanModelPortfolios ?? []}
                                                            placeholder=""
                                                            onChange={(selectedOptions) =>
                                                            {
                                                                setSelectedModelPortfolio(selectedOptions[0]?.value || undefined)
                                                            }}
                                                            values={
                                                                selectedModelPortfolio
                                                                    ? [
                                                                        // Busca el label asociado al value seleccionado
                                                                        {
                                                                            value: selectedModelPortfolio,
                                                                            label: savingPlanModelPortfolios?.find(
                                                                                (portfolio) => portfolio.value === selectedModelPortfolio
                                                                            )?.label || "", // Si no se encuentra, deja un string vacío
                                                                        },
                                                                    ]
                                                                    : []
                                                            }
                                                            searchable={false}
                                                            required
                                                        />
                                                    </CompetitionSelectCont>
                                                    {!chargedModelPortfolio && <div style={{ marginLeft: "20px", marginTop: "30px" }}>
                                                        <Spinner size={SpinnerSize.small} style={{ marginTop: "60x" }} className="button-spinner" />
                                                    </div>}
                                                </div>
                                                {haveError && selectedModelPortfolio === undefined && (
                                                    <p className="ms-Grid-col ms-sm6 ms-md6 ms-lg6 ms-xl6" style={{ color: "red" }}>
                                                        Debes seleccionar al menos una cartera modelo
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{
                                        display: 'flex', justifyContent: "right",
                                        marginTop: "20px"
                                    }}>
                                        <DefaultButton
                                            className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 ms-xl1 button tiny-primary-button"
                                            onClick={() => history.push("/competitions")}
                                            disabled={sending}
                                        >
                                            Cancelar
                                        </DefaultButton>

                                        <DefaultButton
                                            className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 ms-xl1 button tiny-primary-button"
                                            type="submit"
                                            disabled={sending}
                                        >
                                            {sending && (
                                                <Spinner
                                                    size={SpinnerSize.small}
                                                    className="button-spinner"
                                                />
                                            )}
                                            Crear
                                        </DefaultButton>
                                    </div>
                                </div>
                            </form>
                        </article>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignContent: "center",
                                width: "50%",
                            }}
                        >
                            {(name !== "" || startDate !== "" || endDate !== "" || description !== "") && (
                                <article
                                    className={`${styles.littlecard} ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3 rounded background-background`}
                                >
                                    <header>
                                        <div style={{ display: "flex" }}>
                                            <p
                                                style={{
                                                    marginBottom: "0px !important",
                                                    fontSize: "16px",
                                                    fontWeight: "600",
                                                    wordBreak: "break-word",
                                                }}
                                            >
                                                {name}
                                            </p>
                                        </div>
                                        {startDate !== "" && endDate !== "" && (
                                            <p>
                                                Del {startDate} al {endDate}
                                            </p>
                                        )}
                                    </header>
                                    {/* Vista previa como texto, igual que la tarjeta que verán los demás (auditoría G4-07) */}
                                    <main style={{ marginTop: "10px", wordBreak: "break-word" }}>
                                        {description}
                                    </main>
                                    <footer
                                        style={{
                                            backgroundColor: "white",
                                            position: "absolute",
                                            bottom: "4px",
                                            left: "0", // Asegura que el footer se posicione desde la izquierda
                                            width: "100%", // Opcional, ajusta el ancho según necesites
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "0 10px", // Añade espacio horizontal entre los elementos
                                            boxSizing: "border-box",
                                            paddingLeft: "20px",
                                            paddingRight: "20px",
                                            paddingTop: "20px",
                                            paddingBottom: "20px",
                                        }}
                                    >
                                        <span className={styles.type}>Tipo: {CompetitionTypes[selectedValueType ? 1 : 0]}</span>
                                        <span className={styles.price}>
                                            {parseInt(price) === 0 ? (
                                                <>Inscripción gratuita</>
                                            ) : (
                                                <>
                                                    {price !== undefined
                                                        ? currencyNeutreFormatter.format(parseInt(price))
                                                        : 0}{" "}
                                                    Elements {selectedValueCompetition ? "Agua" : "IA"}
                                                </>
                                            )}
                                        </span>
                                    </footer>
                                </article>
                            )}
                            {(name !== "" || startDate !== "" || endDate !== "" || description !== "") && (
                                <p
                                    style={{
                                        alignSelf: "center",
                                        marginTop: "10px",
                                        width: "45%",
                                        fontSize: "17px",
                                        textAlign: "justify",
                                        color: "rgb(85, 103, 105)",
                                    }}
                                >
                                    Crear una competición significa participar en ella. Sí pulsa
                                    en crear se le restarán {price} de Elements{" "}
                                    {selectedValueCompetition ? "Agua" : "IA"}.
                                </p>
                            )}
                        </div>
                    </div>
                )}
                {isModal && (
                    <GenericMessageModalWithoutButton
                        title="Curso creado e inscripción registrada"
                        body={
                            <p>
                                Hemos registrado el curso en la base de datos. Recuerda que su
                                creación conllevaba participar en ella, por lo que has utilizado{" "}
                                {price} Elements {selectedValueCompetition ? "Agua" : "IA"}.
                            </p>
                        }
                        btnSubmitText="Aceptar"
                        showModal={showModal}
                        onSubmit={() =>
                        {
                            setShowModal(false);
                            history.push("/competitions");
                        }}
                        onClose={() =>
                        {
                            setShowModal(false);
                            history.push("/competitions");
                        }}
                    ></GenericMessageModalWithoutButton>
                )}
            </section>
        </DocumentTitle>
    );
};

export default CompetitionNew;